import React, { Component } from 'react'
import DoughnutChart from 'components/charts/doughnut-chart'
import Loader from 'components/loader/loader'

import { 
	doSort,
	getColour,
	getStatusName,
	getPrimaryColumnValue
} from 'utils'

export default class StatusOverview extends Component {
	generateChartData = _ => {
		const {
			project,
			allStatuses,
			allMilestones,
			allTasks
		} = this.props

		let statusGroups = []
		let hasNull = false
		let total = 0

		project && project.milestones.forEach(milestoneId => {
			const milestone = allMilestones[milestoneId]

			milestone && milestone.tasks && milestone.tasks.forEach(taskId => {
				const task = allTasks[taskId]

				const statusId = getPrimaryColumnValue('status', task, project)

				if(task){
					total++

					const statusGroupIndex = statusGroups.findIndex(group => {
						return group.id == statusId
					})

					if(statusGroupIndex > -1){
						statusGroups[statusGroupIndex].count++
					}else{
						statusGroups.push({
							id: statusId,
							count: 1
						})
					}
				}
			})
		})

		const data = {
			datasets: [{
				backgroundColor: [],
				borderWidth: 0,
				data: [],
				hoverBackgroundColor: [],
				lastAsEmpty: hasNull,
				totalItems: total
			}],
			labels: [[]]
		}

		const legend = []

		statusGroups = doSort(statusGroups, 'number', 'count', true)

		const nullGroupIndex = statusGroups.findIndex(group => {
			return group.id == null
		})

		if(nullGroupIndex !== -1){
			hasNull = true

			const nullGroup = statusGroups[nullGroupIndex]

			statusGroups.splice(nullGroupIndex, 1)

			statusGroups.push(nullGroup)
		}

		statusGroups.forEach(statusGroup => {
			let statusName = ''
			let statusColour = null

			if(statusGroup.id){
				statusName = getStatusName(statusGroup.id, project, allStatuses)
				statusColour = getColour(statusGroup.id, 'status')
			}else{
				statusName = 'None'
				statusColour = null
			}

			if(statusColour){
				data.datasets[0].backgroundColor.push(statusColour)
				data.datasets[0].hoverBackgroundColor.push(statusColour)
			}

			data.datasets[0].data.push(statusGroup.count)
			data.labels[0].push(statusName)

			legend.push({
				name: statusName,
				percent: 40,
				seconds: 10
			})
		})

		return {
			data,
			legend
		}
	}

	render() {
		const {
			loading
		} = this.props

		const chartData = this.generateChartData()

		return (
			<div className="widget box">
				<h3>
					Status overview
				</h3>
				<div>
					<DoughnutChart 
						//isDataFake={this.isDataFake}
						type="status"
						data={chartData.data}
						legendData={chartData.legend}
						showLegend={false}
						loading={loading}
					/>
				</div>
			</div>   
		)
	}
}
